import React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import logo from '../img/UDM.png';
import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router'
import {API_URL} from '../index'
import { TextareaAutosize } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';


function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'ГКУ "ГАСПД УР" (c) 2019'}
        </Typography>
    );
}

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    img: {
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));


export default function Login(props) {

    const classes = useStyles();

    const [username, setUsername] = useState('USERNAME');
    const [password, setPassword] = useState('PASSWORD');
    const [redirect, setRedirect] = useState(false);
    const [login_error, setLoginError] = useState([]);

    const usernameRef = useRef();
    const emailRef = useRef();
    const passwordRef = useRef();

    const [open_inform, setOpenInform] = React.useState(false);
    const openInform = () => setOpenInform(true);
    const closeInform = () => {setOpenInform(false); setText(null); setEmail(null)}
    const [email, setEmail] = useState(null);
    const [text, setText] = useState(null);
    const [email_helper, setEmailHelper] = useState(false);
    const [text_helper, setTextHelper] = useState(false);

  const onChangeInformEmail = (e) => {
    setEmail(e.target.value)
  }

  const onChangeInformText = (e) => {
    setText(e.target.value)
  }

    const getUsername = () => {
        setUsername(usernameRef.current.value);
    };

    const getPassword = () => {
        setPassword(passwordRef.current.value);
    };

    const SignIn = () => {
        const login_url = API_URL + 'rest-auth/login/'
        const login_data = {username: usernameRef.current.value,
                            password: passwordRef.current.value}

        fetch(login_url, {
            method: 'POST',
            body: JSON.stringify(login_data),
            headers:{ 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .then(data => 
                data.key ?
                (localStorage.setItem('token', data.key), setRedirect(true), props.updateLoginData()) :
                setLoginError(data))

    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            SignIn();
        }
    }

    if (redirect) {
        return <Redirect to='/'/>;
    }

  const sendInform = () => {
    email == null | email == '' ? setEmailHelper('обязательное поле') : setEmailHelper(false);
    text == null | text == '' ? setTextHelper('обязательное поле') : setTextHelper(false);
    if (email != null & email != '' & text != null & text != '')
        fetch(API_URL + 'owner_less_docs/', {
          method: 'POST',
          body: JSON.stringify({
              'email': email,
              'text': text
          }),
          headers: { 'Content-Type': 'application/json' }
        })
        .then(response => {if (response.status == 201)
            {setOpenInform(false); setEmail(null); setText(null)}
        else
            return response.json()})
        .then(data => {
            data.email != undefined ? setEmailHelper(data.email) : setEmailHelper(false)
            data.text != undefined ? setTextHelper(data.text) : setTextHelper(false)
        })
  }

  const style_inform = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: '40%',
    bgcolor: 'background.paper',
    border: 0,
    boxShadow: 24,
    p: 10,
  };

    return (
        <Container component="main" maxWidth="xs">
        <h5 style={{color: '#ff845c'}}>{props.message ? props.message.detail : <div></div>}</h5>
        <Typography variant="h6" component="h4" >
          Местонахождение документов по личному составу
        </Typography>
            <CssBaseline />
            <div>
                <img class="fit-picture"
                     src={logo}
                     alt="logo"
                     height="150"
                />
        <Typography component="p">
          база данных
        </Typography>
                <Typography component="h1" variant="h5" className={classes.paper}>
                    Вход
                </Typography>
                <form className={classes.form} noValidate onKeyPress={handleKeyPress}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="username"
                                label="Имя пользователя"
                                name="username"
                                autoComplete="username"
                                autoFocus
                                inputRef={usernameRef}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label="Пароль"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                inputRef={passwordRef}
                                error={login_error.password ? login_error.password : false}
                                helperText={login_error.password ? login_error.password : false}
                            />
                        </Grid>
                    </Grid>
                    <h5 style={{color: 'red'}}>{login_error.non_field_errors ?
                                                login_error.non_field_errors :
                                                false}</h5>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={SignIn}
                    >
                        Войти
                    </Button>
                    <Grid container justify="flex-end">
                        <Grid item>
                            <Link button onClick={e => props.LoginAsGuest()}>
                                Продолжить без аутентификации (доступна функция поиска в базе)
                            </Link>
                            <p></p>
                            <Link button onClick={e => openInform()}>
                                Информирование архивного учреждения о бесхозяйных (разыскиваемых) документах
                            </Link>

                            <Modal
                              open={open_inform}
                              onClose={closeInform}
                              aria-labelledby="modal-modal-title"
                              aria-describedby="modal-modal-description"
                            >
                            <Box sx={style_inform}>
                            <h3>Информирование архивного учреждения о бесхозяйных (разыскиваемых) документах</h3>
                            <TextField label="Email"
                                required onChange={onChangeInformEmail}
                                helperText={email_helper}
                                error={email_helper}></TextField>
                            <p></p>
                            <TextareaAutosize required aria-label="empty textarea" placeholder="Информация о документах" minRows={5}
                                style={{ width: "65%" }} onChange={onChangeInformText}/>
                            <div style={{color: 'red'}}>{text_helper}</div>
                            <p></p>
                            <Button variant="contained" color="primary" onClick={sendInform}>Отправить</Button>
                            </Box>
                            </Modal>

                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={5}>
                <Copyright />
            </Box>
        </Container>
    );
}